import {
  PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_BEGIN,
  PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_SUCCESS,
  PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_FAILURE,
  PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadInstalledPluginDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_BEGIN,
    });

    const { projectId, version, installedPluginId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/${installedPluginId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_SUCCESS,
            data: res.data.setting ? res.data.setting : '',
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadInstalledPluginDetailError() {
  return {
    type: PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_BEGIN:
      return {
        ...state,
        loadInstalledPluginDetailPending: true,
        loadInstalledPluginDetailError: null,
      };

    case PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_SUCCESS:
      return {
        ...state,
        loadInstalledPluginDetailPending: false,
        loadInstalledPluginDetailError: null,
        pluginDetail: action.data,
      };

    case PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_FAILURE:
      return {
        ...state,
        loadInstalledPluginDetailPending: false,
        loadInstalledPluginDetailError: action.data.error,
      };

    case PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadInstalledPluginDetailError: null,
      };

    default:
      return state;
  }
}
